import makeStyles from '@mui/styles/makeStyles'
import { CSSProperties } from '@mui/styles/withStyles'

export const scrollbarStyles: CSSProperties = {
    // Apply styles to the container that should have scrollbars
    overflow: 'auto',
    '&::-webkit-scrollbar': {
        width: '8px'
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: 5
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: 5
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
        borderRadius: 5
    }
}

export const useCustomScrollbar = makeStyles(() => ({
    customScrollbar: scrollbarStyles
}))

export const useStaticStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
        marginBottom: '1vh'
    },
    descriptionWrapper: {
        marginTop: '2vh',
        marginBottom: '2vh',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    imageWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '2vh'
    },
    imageStyle: {
        maxWidth: 90,
        maxHeight: '10vh'
    },
    fileUpload: {
        borderColor: theme.palette.grey[400],
        minWidth: '100%'
    }
}))
